import { useState, useEffect } from 'react';
import { songService } from '../services/api';

export const useSearch = (query, voicePart, collection) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchResults = async () => {
      if (!query || query.length < 2) {
        setResults([]);
        return;
      }

      setLoading(true);
      const startTime = performance.now();
      
      try {
        const data = await songService.searchSongs(query, voicePart, collection);
        setResults(data);
        setError(null);
        
        // Track successful search in Umami
        if (window.umami) {
          const latencyMs = Math.round(performance.now() - startTime);
          window.umami.track('Search Performed', { 
            query: query.toLowerCase(),
            results_count: data.length,
            latency_ms: latencyMs,
            voicePart: voicePart || 'all',
            collection: collection || 'all'
          });
        }
      } catch (err) {
        // Use the specific error message from backend if available (e.g. rate limit)
        const message = err.response?.data?.detail || 'Failed to fetch songs';
        setError(message);
        
        // Track failed search
        if (window.umami) {
          window.umami.track('Search Error', { 
            query: query,
            error: message
          });
        }
      } finally {
        setLoading(false);
      }
    };

    // Fetch immediately as search is now triggered by Enter
    fetchResults();
  }, [query, voicePart, collection]);

  return { results, loading, error };
};
